import { BaseState } from '@/store/base-state';
import { DataPilot } from '@/modules/data-pilot/types';
import { Filters, TableOptions } from '@/types';

export class EventHistoryState extends BaseState {
  filters: Filters = {
    search: '',
    tag_ids: [],
    event_ids: [],
    addresses: [],
    period: [],
    user_ids: [],
    related_entity_ids: [],
    client_id: null,
  };

  comments: string[] = [];
  events: DataPilot.Event[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  loading = false;
}
